import {
  AddToCartError,
  BUSINESS_VALIDATION_CAUSE_ERRORS,
  SDK_CART_ERRORS,
  SdkBusinessValidationCauseErrorType,
} from '@photosi/expo-photosi-sdk/build/Cart';
import { PRODUCT_NOT_AVAILABLE_ERROR_TYPE } from 'src/helpers/error.helper';

export function getActiveElementBy<T extends { id: string }>(
  prop: T | number | string | undefined,
  elementList: T[] = [],
): T | undefined {
  let activeElement: T | undefined;
  switch (typeof prop) {
    case 'number':
      activeElement = elementList[prop];
      break;
    case 'string':
      activeElement = elementList.find(product => product.id === prop);
      break;
    default:
      activeElement = prop;
      break;
  }

  return activeElement;
}

// Sanitize del code: se non è uno dei codici noti di SDK_CART_ERRORS lo collassiamo
// a 'UNKNOWN' per evitare cardinality explosion su Datadog (errorType può essere
// una message free-form quando error.errorCode è missing — es. errore JS escape).
// Violazioni di regole di business/validazione: NON sono errori di sistema ma
// esiti attesi (prodotto sotto il minimo foto / limiti di gruppo / prodotto non disponibile).
// Le teniamo FUORI da Sentry, ma le tracciamo su Datadog col loro codice REALE — così
// possono finire in una dashboard dedicata ed essere filtrate esplicitamente dalla
// failure metric principale, invece di confluire in UNKNOWN.
export const getSafeErrorCode = ({
  errorType,
  errorCauseCode,
  isProductNotAvailable,
}: {
  errorType: string;
  errorCauseCode?: string;
  isProductNotAvailable: boolean;
}): string => {
  if (isProductNotAvailable) {
    return PRODUCT_NOT_AVAILABLE_ERROR_TYPE;
  }
  if (
    errorCauseCode &&
    Object.values(BUSINESS_VALIDATION_CAUSE_ERRORS).includes(errorCauseCode as SdkBusinessValidationCauseErrorType)
  ) {
    return errorCauseCode;
  }
  if (Object.values(SDK_CART_ERRORS).includes(errorType as AddToCartError['errorCode'])) {
    return errorType;
  }
  return SDK_CART_ERRORS.UNKNOWN;
};
